import React, { useCallback, useEffect, useState } from 'react';

// import api from '../../services/api';
// import { API_URL_DISTANCES } from '../../services/api/routes';
import 'jquery-mask-plugin/dist/jquery.mask.min';

import { collection, query, where, getDocs } from 'firebase/firestore';
import {
  Container,
  Overlay,
  Header,
  Resume,
  SelectContainer,
  Error,
  InputContainer,
} from './styles';

import { DB } from '~/services/firebase';
import { useCartCompany } from '../../../../hooks/cartCompany';
import viacep from '../../../../services/viacep';
import IAddress from '~/interfaces/IAddress';
import IDistance from '~/interfaces/IDistance';
import { useAuth } from '~/hooks/auth';
import { useClients } from '~/hooks/clients';
import { getAddressClientPOS } from '~/utils/getAddressClientPOS';

const { REACT_APP_POS_SIMPLE_ADDRESS } = process.env;

const OrderAddress: React.FC = () => {
  const {
    setShowConfirmOrder,
    setShowOrderAddress,
    setOrderAddress,
    orderAddressText,
    setOrderAddressText,
  } = useCartCompany();
  const { company } = useAuth();
  const { selectedClient } = useClients();

  // const {
  //   distances,
  //   setOrderAddress,
  //   deliveryType,
  //   setDeliveryType,
  //   orderAddress,
  // } = useDistances();

  const [errors, setErrors] = useState({} as any);
  const [data, setData] = useState({} as IAddress);
  const [loading, setLoading] = useState(false);

  const [deliveryType, setDeliveryType] = useState('Delivery');
  const [distances, setDistances] = useState<IDistance[]>([]);
  const [locality, setLocality] = useState('');

  useEffect(() => {
    setOrderAddressText(getAddressClientPOS(selectedClient));
  }, [selectedClient, setOrderAddressText]);

  // useEffect(() => {
  //   setData(orderAddress);
  // }, [orderAddress]);

  useEffect(() => {
    async function loadDistances() {
      const q = query(
        collection(DB, 'distances'),
        where('company_id', '==', company.uid),
      );
      const querySnapshot = await getDocs(q);

      const items: IDistance[] = [];

      querySnapshot.docs.forEach(item => {
        const parseItem = {
          ...item.data(),
          uid: item.id,
        } as IDistance;

        items.push(parseItem);
      });

      // items.sort((a, b) => (a.from > b.from ? 1 : b.from > a.from ? -1 : 0));
      const sorted = items.sort((a, b) =>
        a.district?.toLocaleLowerCase() > b.district?.toLocaleLowerCase()
          ? 1
          : b.district?.toLocaleLowerCase() > a.district?.toLocaleLowerCase()
          ? -1
          : 0,
      );

      const bairro = selectedClient.neighborhood || '';

      if (bairro) {
        const findLocality = sorted.filter(item =>
          item.district.toLowerCase().includes(bairro.toLowerCase()),
        );

        if (findLocality.length > 0) {
          setLocality(findLocality[0].uid);
          setData(old => ({
            ...old,
            neighbourhood: findLocality[0].district,
            distance: {
              value: findLocality[0].value,
              text: '',
            },
          }));
        }
      }

      setDistances(sorted);
    }

    if (company && company.uid) loadDistances();
  }, [company, selectedClient]);

  const handleChangePostcode = useCallback(
    async (event: any) => {
      try {
        const { value } = event.target;
        setData({ ...data, postcode: value });

        const parseValue = value.replace('-', '');

        if (parseValue.length === 8) {
          const response = await viacep.get(`${value}/json`);
          const dataAddress = response.data;

          const findDistance = distances.find(
            distance =>
              distance.district &&
              distance.district.toLowerCase().trim() ===
                dataAddress.bairro.toLowerCase().trim(),
          );

          console.log(findDistance);

          setData({
            ...data,
            road: dataAddress.logradouro || '',
            neighbourhood: dataAddress.bairro || '',
            city: dataAddress.localidade || '',
            state: dataAddress.uf || '',
            complement: dataAddress.complemento || '',
            postcode: dataAddress.cep,
            uid: findDistance ? findDistance.uid : '',
            distance: {
              value: findDistance ? findDistance.value : 0,
              text: '',
            },
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    [data, distances],
  );

  const handleChangeNeighborhood = useCallback(
    event => {
      const { value } = event.target;

      const findDistance = distances.find(distance => distance.uid === value);

      if (findDistance) {
        setData({
          ...data,
          neighbourhood: findDistance.district,
          uid: value,
          distance: {
            value: findDistance.value,
            text: '',
          },
        });
      } else {
        setData({ ...data, uid: value });
      }
    },
    [distances, data],
  );

  // const handleVerificationAddress = useCallback(async () => {
  //   try {
  //     setLoading(true);

  //     const response = await api.post(
  //       `${appDomain}/${API_URL_DISTANCES}`,
  //       data,
  //     );

  //     setLoading(false);

  //     return response.data;
  //   } catch (err: any) {
  //     setLoading(false);
  //     console.log(err.message);

  //     return null;
  //   }
  // }, [data, appDomain]);

  const handleChangeLocality = useCallback(
    (event: any) => {
      const distance_id = event.target.value;
      setLocality(distance_id);

      if (distance_id) {
        const findDistance = distances.find(
          distance => distance.uid === distance_id,
        );

        if (findDistance) {
          setData({
            ...data,
            uid: distance_id,
            neighbourhood: findDistance.district,
            distance: {
              value: findDistance.value,
              text: '',
            },
          });
        }
      }
    },
    [distances, data],
  );

  const handleSubmit = useCallback(async () => {
    if (deliveryType === 'Delivery') {
      if (!REACT_APP_POS_SIMPLE_ADDRESS) {
        let err = {};

        if (!data.number) err = { ...err, number: '* Campo Obrigatório' };
        if (!data.city) err = { ...err, city: '* Campo Obrigatório' };
        if (!data.road) err = { ...err, road: '* Campo Obrigatório' };
        if (!data.neighbourhood)
          err = { ...err, neighbourhood: '* Campo Obrigatório' };

        setErrors(err);

        if (Object.keys(err).length > 0) {
          return;
        }

        // const verificationAddress = await handleVerificationAddress();
        // if (!verificationAddress) {
        //   setErrors({
        //     address: 'Desculpe. Ainda não atendemos o endereço informado.',
        //   });
        //   return;
        // }

        const parseData = {
          ...data,
        };

        if (parseData.distance && company.free_delivery === '1') {
          parseData.distance.value = 0;
        }

        setOrderAddress(parseData);
      } else {
        // if (!locality) {
        //   setErrors({ locality: '* Campo Obrigatório' });
        //   return;
        // }

        setOrderAddressText(
          orderAddressText
            ? `${orderAddressText}${
                data.neighbourhood ? `, ${data.neighbourhood}` : ''
              }`
            : data.neighbourhood,
        );

        const parseData = {
          ...data,
        };

        if (parseData.distance && company.free_delivery === '1') {
          parseData.distance.value = 0;
        }

        setOrderAddress(parseData);
      }
    } else {
      setOrderAddress({} as IAddress);
      setOrderAddressText('');
    }

    setShowOrderAddress(false);
    setShowConfirmOrder(true);
  }, [
    orderAddressText,
    setOrderAddressText,
    setShowConfirmOrder,
    setOrderAddress,
    company,
    data,
    // handleVerificationAddress,
    setShowOrderAddress,
    deliveryType,
    locality,
  ]);

  return (
    <>
      <Container>
        <div style={{ marginTop: 60 }}>
          <Header>
            <h3>POS Tem Pedido</h3>
            <div
              role="button"
              className="toggle btn btn-icon p-2 btn-secundary"
              onClick={() => setShowOrderAddress(false)}
            >
              <i className="fa fa-times" style={{ fontSize: 18 }} />
            </div>
          </Header>

          <Resume>
            {errors.address && <Error>{errors.address}</Error>}

            <label htmlFor="">Forma de entrega</label>
            <SelectContainer>
              <select
                id="delivery_type"
                value={deliveryType}
                onChange={event => {
                  setDeliveryType(event.target.value);
                }}
              >
                <option value="Delivery">Delivery</option>
                <option value="Retirada-Local">Retirada Local</option>
              </select>
            </SelectContainer>

            {deliveryType === 'Delivery' && REACT_APP_POS_SIMPLE_ADDRESS && (
              <>
                <label htmlFor="">Localidade</label>
                <SelectContainer>
                  <select
                    value={locality}
                    onChange={ev => handleChangeLocality(ev)}
                  >
                    <option value="">Selecione...</option>
                    {distances.map(item => (
                      <option value={item.uid}>{item.district}</option>
                    ))}
                  </select>
                </SelectContainer>
                {errors.locality && (
                  <p
                    className="text-danger"
                    style={{ fontSize: 12, marginTop: -4 }}
                  >
                    {errors.locality}
                  </p>
                )}
                {locality && (() => {
                  const selectedDistance = distances.find(d => d.uid === locality);
                  return selectedDistance?.observations ? (
                    <div
                      style={{
                        backgroundColor: '#fff3cd',
                        border: '1px solid #ffeaa7',
                        borderRadius: '4px',
                        padding: '8px 12px',
                        marginTop: '8px',
                        marginBottom: '8px',
                        fontSize: '14px',
                        color: '#856404'
                      }}
                    >
                      {selectedDistance.observations}
                    </div>
                  ) : null;
                })()}
                <label htmlFor="">Endereço de entrega</label>
                <InputContainer>
                  <textarea
                    placeholder="Endereço..."
                    value={orderAddressText}
                    onChange={event => {
                      setOrderAddressText(event.target.value);
                    }}
                  />
                </InputContainer>
              </>
            )}

            {deliveryType === 'Delivery' && !REACT_APP_POS_SIMPLE_ADDRESS && (
              <main>
                <label htmlFor="">CEP</label>
                <InputContainer>
                  <input
                    type="text"
                    placeholder="CEP"
                    value={data.postcode}
                    onChange={handleChangePostcode}
                  />
                </InputContainer>

                <label htmlFor="">Endereço</label>
                <InputContainer>
                  <input
                    type="text"
                    placeholder="Informe o endereço..."
                    value={data.road}
                    onChange={event => {
                      setData({
                        ...data,
                        road: event.target.value,
                      });
                    }}
                  />
                </InputContainer>
                {errors.road && (
                  <p
                    className="text-danger"
                    style={{ fontSize: 12, marginTop: -4 }}
                  >
                    {errors.road}
                  </p>
                )}

                <label>Número</label>
                <InputContainer>
                  <input
                    type="text"
                    placeholder="Informe o número do endereço..."
                    value={data.number}
                    onChange={event => {
                      setData({
                        ...data,
                        number: event.target.value,
                      });
                    }}
                  />
                </InputContainer>
                {errors.number && (
                  <p
                    className="text-danger"
                    style={{ fontSize: 12, marginTop: -4 }}
                  >
                    {errors.number}
                  </p>
                )}

                <label htmlFor="">Complemento</label>
                <InputContainer>
                  <input
                    type="text"
                    placeholder="Complemento..."
                    value={data.complement}
                    onChange={event => {
                      setData({
                        ...data,
                        complement: event.target.value,
                      });
                    }}
                  />
                </InputContainer>

                <label htmlFor="">Referência</label>
                <InputContainer>
                  <input
                    type="text"
                    placeholder="Referência..."
                    value={data.reference}
                    onChange={event => {
                      setData({
                        ...data,
                        reference: event.target.value,
                      });
                    }}
                  />
                </InputContainer>

                <label htmlFor="">Estado</label>
                <InputContainer>
                  <input
                    type="text"
                    placeholder="Estado"
                    value={data.state}
                    onChange={event => {
                      setData({
                        ...data,
                        state: event.target.value,
                      });
                    }}
                  />
                </InputContainer>

                <label htmlFor="">Cidade</label>
                <InputContainer>
                  <input
                    type="text"
                    placeholder="Informe a cidade..."
                    value={data.city}
                    onChange={event => {
                      setData({
                        ...data,
                        city: event.target.value,
                      });
                    }}
                  />
                </InputContainer>
                {errors.city && (
                  <p
                    className="text-danger"
                    style={{ fontSize: 12, marginTop: -4 }}
                  >
                    {errors.city}
                  </p>
                )}

                <label htmlFor="">Bairro</label>

                {/* <SelectContainer>
                  <select
                    id="neighborhood"
                    value={data.uid}
                    onChange={handleChangeNeighborhood}
                  >
                    <option value="">Escolha o bairro...</option>
                    {distances.map(item => (
                      <option value={item.uid}>{item.district}</option>
                    ))}
                  </select>
                </SelectContainer> */}

                <InputContainer>
                  <input
                    type="text"
                    placeholder="Informe o bairro..."
                    value={data.neighbourhood}
                    onChange={event => {
                      setData({
                        ...data,
                        neighbourhood: event.target.value,
                      });
                    }}
                  />
                </InputContainer>

                {errors.neighbourhood && (
                  <p
                    className="text-danger"
                    style={{ fontSize: 12, marginTop: -4 }}
                  >
                    {errors.neighbourhood}
                  </p>
                )}
              </main>
            )}

            <button type="button" disabled={loading} onClick={handleSubmit}>
              {loading && (
                <div className="d-flex justify-content-center">
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden" />
                  </div>
                </div>
              )}
              {!loading && 'CONTINUAR'}
            </button>
          </Resume>
        </div>
      </Container>
      <Overlay onClick={() => setShowOrderAddress(false)} />
    </>
  );
};

export default OrderAddress;
